// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import ChildSafety_PG_Content from './PageComponent/ChildSafety_PG_Content';

function ChildSafety() {

    useMeta({
        title: 'Child Safety | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/child-safety/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Child Safety | Callistus Blinds',
            description:
                'Children are unsurprisingly curious about the world just about them. So, even basic household items like window blinds can turn into prospective hazards for them. Making our window blinds safer for homes with infants, young children and pets is a top priority at Callistus. So we developed a wide range of operating system to help […]',
            url: 'https://callistusblinds.com/child-safety/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <ChildSafety_PG_Content />
            <Footer />
        </div>
    );
}

export default ChildSafety;
